var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-underline"},[_c('RouterLink',{attrs:{"tag":"button","to":_vm.to},domProps:{"innerHTML":_vm._s(_vm.label)},nativeOn:{"click":function($event){return _vm.click($event)}}}),_c('div')],1)}
var staticRenderFns = []

export { render, staticRenderFns }